export default __webpack_public_path__ + "static/media/spa-image-09.bdc89f69.jpg";